import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  max-width: 400px;
  height: 400px;
  border-radius: 8px;
  padding-bottom: 15px;
  flex: 1;

  overflow-y: auto;
  
  background-color: #fff;
`;

export const Header = styled.div`
  display: -webkit-flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
`;

export const OrderItem = styled.div`
  display: -webkit-flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`; 